import type { SxProps, Theme } from '@mui/material/styles';

export const sessionExpiryModalStyles: Record<string, SxProps<Theme>> = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: { xs: 0, sm: 320 },
  },
  countdownRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 1,
  },
  countdown: {
    fontVariantNumeric: 'tabular-nums',
    fontWeight: 600,
  },
  progress: {
    mt: 1,
  },
};
